import type { UsageSeriesPoint } from './api';
import { getUtilityPresentation } from './utilityPresentation';
import { UtilityUsageChart } from './UtilityUsageChart';

interface UsageChartProps {
  series: UsageSeriesPoint[];
  registerCode?: string;
  mode?: 'cumulative' | 'delta';
  height?: number;
  /** Utility type name drives chart variant and color. */
  utilityName?: string;
  color?: string;
  variant?: 'area' | 'bar' | 'line';
}

/** Detail-screen usage chart — delegates to UtilityUsageChart. */
export function UsageChart({
  series,
  registerCode,
  mode = 'cumulative',
  height = 180,
  utilityName = 'Utility',
  color,
  variant,
}: UsageChartProps): JSX.Element {
  const presentation = getUtilityPresentation(utilityName);
  return (
    <UtilityUsageChart
      series={series}
      registerCode={registerCode}
      mode={mode}
      variant={variant ?? presentation.chartKind}
      color={color ?? presentation.color}
      size="full"
      height={height}
      emptyMessage="No readings yet for this register."
    />
  );
}
